import * as yup from "yup";
import { strToNumericStr } from "./form-converters";

export const createMinMaxValidation = (maxFieldName: string) =>
  yup
    .string()
    .test("min-max-validation", `Min must be less than max`, function (value) {
      const maxValue = this.parent[maxFieldName];
      if (!value || !maxValue) return true; // Skip validation if either is empty

      // Strip formatting for comparison
      const numericMinValue = strToNumericStr(value);
      const numericMaxValue = strToNumericStr(maxValue);

      return parseInt(numericMinValue) <= parseInt(numericMaxValue);
    });

export const createOptionalNumericValidation = (fieldName: string) => {
  return yup
    .string()
    .test("is-valid-number", `${fieldName} must be a valid number`, (value) => {
      if (!value || value === "") return true;

      const numericValue = strToNumericStr(value);

      return /^\d+$/.test(numericValue);
    });
};

export const createOptionalNumericValidationWithMax = (
  fieldName: string,
  maxValue: number
) => {
  return yup
    .string()
    .test("is-valid-number", `${fieldName} must be a valid number`, (value) => {
      if (!value || value === "") return true;

      const numericValue = strToNumericStr(value);

      return /^\d+$/.test(numericValue);
    })
    .test(
      "max-value",
      `${fieldName} must be less than or equal to ${maxValue.toLocaleString()}`,
      (value) => {
        if (!value || value === "") return true;

        const numericValue = strToNumericStr(value);
        const numberValue = Number(numericValue);

        return numberValue <= maxValue;
      }
    );
};
